// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.erreur-popup {
  background-color: #FFFDFC;
  border-radius: 10px;
  padding: 1.5rem;
  width: 90%;
  max-width: 480px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  position: relative;
  animation: slideIn 0.3s ease-out forwards;
}

.erreur-popup-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid rgba(231, 76, 60, 0.2);
  position: relative;
}

.erreur-popup-icon {
  margin-right: 12px;
  color: #e74c3c;
  display: flex;
  align-items: center;
  justify-content: center;
}

.erreur-popup-header h2 {
  margin: 0;
  font-size: 1.5rem;
  color: #e74c3c;
  font-weight: 600;
  flex-grow: 1;
}

.erreur-popup-close {
  background: none;
  border: none;
  color: #6c757d;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
}

.erreur-popup-close:hover {
  background-color: rgba(108, 117, 125, 0.1);
}

.erreur-popup-body {
  margin-bottom: 1.5rem;
}

.erreur-popup-message {
  font-size: 1.5rem;
  line-height: 1.5;
  margin-bottom: 1rem;
  color: #333;
}

.erreur-popup-details {
  background-color: #f8f9fa;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  font-size: 0.9rem;
  margin-top: 1rem;
  border: 1px solid #e9ecef;
}

.erreur-popup-details summary {
  cursor: pointer;
  color: #6c757d;
  font-weight: 500;
  padding: 4px 0;
  outline: none;
}

.erreur-popup-details summary:hover {
  color: #e74c3c;
}

.erreur-popup-details p {
  margin-top: 8px;
  margin-bottom: 4px;
  font-family: monospace;
  white-space: pre-wrap;
  color: #495057;
  padding: 8px;
  background: rgba(231, 76, 60, 0.05);
  border-radius: 4px;
}

.erreur-popup-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 1.5rem;
}

/* Animation d'entrée */
@keyframes slideIn {
  from {
    transform: translateY(-30px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/composants/ErreurPopUp/ErreurPopUp.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.erreur-popup {\n  background-color: #FFFDFC;\n  border-radius: 10px;\n  padding: 1.5rem;\n  width: 90%;\n  max-width: 480px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  position: relative;\n  animation: slideIn 0.3s ease-out forwards;\n}\n\n.erreur-popup-header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  padding-bottom: 0.75rem;\n  border-bottom: 1px solid rgba(231, 76, 60, 0.2);\n  position: relative;\n}\n\n.erreur-popup-icon {\n  margin-right: 12px;\n  color: #e74c3c;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.erreur-popup-header h2 {\n  margin: 0;\n  font-size: 1.5rem;\n  color: #e74c3c;\n  font-weight: 600;\n  flex-grow: 1;\n}\n\n.erreur-popup-close {\n  background: none;\n  border: none;\n  color: #6c757d;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background-color 0.2s;\n}\n\n.erreur-popup-close:hover {\n  background-color: rgba(108, 117, 125, 0.1);\n}\n\n.erreur-popup-body {\n  margin-bottom: 1.5rem;\n}\n\n.erreur-popup-message {\n  font-size: 1.5rem;\n  line-height: 1.5;\n  margin-bottom: 1rem;\n  color: #333;\n}\n\n.erreur-popup-details {\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  padding: 0.75rem 1rem;\n  font-size: 0.9rem;\n  margin-top: 1rem;\n  border: 1px solid #e9ecef;\n}\n\n.erreur-popup-details summary {\n  cursor: pointer;\n  color: #6c757d;\n  font-weight: 500;\n  padding: 4px 0;\n  outline: none;\n}\n\n.erreur-popup-details summary:hover {\n  color: #e74c3c;\n}\n\n.erreur-popup-details p {\n  margin-top: 8px;\n  margin-bottom: 4px;\n  font-family: monospace;\n  white-space: pre-wrap;\n  color: #495057;\n  padding: 8px;\n  background: rgba(231, 76, 60, 0.05);\n  border-radius: 4px;\n}\n\n.erreur-popup-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 1.5rem;\n}\n\n/* Animation d'entrée */\n@keyframes slideIn {\n  from {\n    transform: translateY(-30px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
